<template>
  <div class="lbv-search animated fadeIn roundedCard">
    <b-card>
      <h1 class="lbv-page-title">
        Disable Chasers
      </h1>
      <form
        class="lbv-search-filter"
        @submit.prevent="disableInstallChasers"
      >
        <b-row class="d-flex w-100 align-items-center justify-content-between">
          <b-col cols="6">
            <b-form-group
              label="Email Address"
              label-for="email-address"
            >
              <input
                v-model="emailString"
                if="email-address"
                type="text"
                class="form-control w-100"
                required
              >
            </b-form-group>
          </b-col>
          <b-col
            cols="6"
            class="text-right"
          >
            <button
              id="applyBtn"
              type="submit"
              class="btn btn-primary applyFilter"
            >
              Submit
            </button>
          </b-col>
        </b-row>
      </form>
    </b-card>
  </div>
</template>

<script>

import ordersMgmt from '../mixins/ordersMgmtMixin'

export default {
  name: 'OrdersMgmt',
  mixins: [ordersMgmt]
}
</script>
